module.exports = "/_next/static/files/4db105431177fdee93f42c8ccf1d51b6.jpg";